var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Color } from '@atomic/obj.constants';
import { corPrimaria } from '../tema';
export var EmptyStateStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 34px 18px;\n  text-align: center;\n  color: ", ";\n"], ["\n  padding: 34px 18px;\n  text-align: center;\n  color: ", ";\n"])), Color.GrayDark);
export var EmptyStateIcon = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 2.6rem;\n  opacity: 0.55;\n  color: ", ";\n"], ["\n  font-size: 2.6rem;\n  opacity: 0.55;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return corPrimaria(theme);
});
export var EmptyStateTitle = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 10px 0 4px;\n  font-weight: 500;\n  color: ", ";\n"], ["\n  margin: 10px 0 4px;\n  font-weight: 500;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.itemColor;
});
export var EmptyStateDescription = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0;\n  font-size: 0.92rem;\n  line-height: 1.4;\n"], ["\n  margin: 0;\n  font-size: 0.92rem;\n  line-height: 1.4;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
